export default __webpack_public_path__ + "static/media/ep_05.2b7f2449.png";